import { IApplicationState, TCardId } from 'app/types/types';
import { getCard } from './getCard';
import { ICalendarEvent } from '../card/types/ICalendarEvent';
import {
    PTGC_ACTIONS_LIST
} from '../../../view/react_components/aside_panel/cardDetails/TimingSection/pushToGoogleCalendar';

export const getCardCalendarCustomEvents = (
    state: IApplicationState,
    cardId: TCardId,
): ICalendarEvent[] => {
    const card = getCard(state, cardId);
    if (
        !card ||
        !card.calendarEvents ||
        !card.calendarEvents.length
    ) return [];

    const dateEvents = PTGC_ACTIONS_LIST.map(action => action.id);
    return card.calendarEvents.filter(event => !dateEvents.includes(event.type));
};
